const theme = {
    primary: '#3C5D30',
    // TODO: Fix it only for buttons
    // primary: '#8F920B',
    primary_action: '#322C3E',
    summary_gray: '#514765',
    secondary: '#6C757D',
    // success: '#25C1AF',
    danger: '#DC3545',
    warning: '#FFC107',
    info: '#17A2B8',
    light: '#F8F9FA',
    dark: '#343A40',
    bodybg: '#F6F4F1',
    status_badge_in_progress: '#717B8F',
    status_badge_ready_to_print: '#316778',
    status_badge_complete: '#B25656',
    maolive: '#8F920B',
    red: '#DB4D4D',

    tooltip: '#000000',
    permission: '#A65A23',

    // Popular in project colors, that are not covered by BJ in Figma/Design System page
    bastille: '#241F2D',
    success: '#25C1AF',
    error: '#DC3545',

    background: {
        primary: '#FFFFFF',
        secondary: '#F6F4ED',
        grey1: '#77767A',
        grey2: '#CECDD0',
    },

    text: {
        primary: '#000000',
        secondary: '#343A40',
    },

    shadow: {
        small: 'box-shadow: 0px 4px 17px rgba(0, 0, 0, 0.15);',
    },

    breakpoints: {
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
    },
};

export default theme;
